<script>
	export let title;
	export let x;
	export let y;

</script>

<div style="
		top: {y + 10}px;
		left: {x + 10}px;"
>{@html title}</div>

<style>
	div {
		border-radius: 4px;
		padding: 4px 6px;
		position: absolute;
		font-size: .8rem;
		color: #fff;
		background-color: #e46937;
		border-color: #f5743f;
		box-shadow: 0 3px 6px rgb(0 0 0 / 29%);
		z-index: 1;
		max-width: 450px;
	}
</style>